let question = document.querySelectorAll(".query");
question.forEach((qsitem) => {
    qsitem.addEventListener("click", function (e) {
        let sibling = qsitem.nextElementSibling;
        question.forEach((item) => {
            item.nextElementSibling.style.height = "0px";
            item != qsitem && item.parentNode.classList.remove("active");
        });
        this.parentNode.classList.toggle("active");
        if (qsitem.parentNode.classList.contains("active")) {
            sibling.style.height = sibling.scrollHeight + "px";
        } else {
            sibling.style.height = "0px";
        }
    });
});
function seeMore(i) {
    var dots = document.getElementById(`dots${i}`);
    var moreText = document.getElementById(`more${i}`);
    var btnText = document.getElementById(`myBtn${i}`);
    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "see more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "see less";
        moreText.style.display = "inline";
    }
    // recalculate height
    document.getElementById(`more${i}`).parentElement.style.height = 'fit-content';
}
